import React from 'react';
import { IconCustom } from 'components';

/**/
export function getExpandIcon() {
  return <IconCustom type="chevron-right" />;
}
